import { useState, useEffect, Fragment } from "react";
import { useLocation, useParams } from "react-router-dom";
import { IconButton } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";

import CaseFloatingSearchDialog from "./CaseFloatingSearchDialog";

export default function CaseFloatingSearch() {
  const location = useLocation();

  const { caseId } = useParams<{ caseId: string }>();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Handle Cmd+K / Ctrl+K ONLY on /admin/cases/:id
  useEffect(() => {
    if (!location.pathname.includes(`/admin/cases/${caseId}`)) return;
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [location.pathname, caseId]);

  return (
    <Fragment>
      {/* Icon button to trigger search */}
      <IconButton
        onClick={handleOpen}
      ><SearchIcon /></IconButton>
      {/* Search dialog */}
      {open ? (
        <CaseFloatingSearchDialog open={open} onClose={handleClose} />
      ) : null}
    </Fragment>
  );
}
